/**
 * RBAC access keys — must match `rbac` values from OTP verify.
 *
 * Sidebar tabs are shown when the user has ANY component key listed for that tab
 * in config/navigation.js (`childPermissions`).
 */

export const RBAC = {
  // ── HR · Dashboard ──────────────────────────────────────────────
  HR_DASHBOARD_STATS: "DASHBOARD.STATS.VIEW_HR_WEB_PAGE",
  HR_DASHBOARD_ATTENDANCE_BREAKDOWN: "DASHBOARD.ATTENDANCE_BREAKDOWN.VIEW_HR_WEB_PAGE",
  HR_DASHBOARD_ATTENDANCE_TABLE: "DASHBOARD.ATTENDANCE_TABLE.VIEW_HR_WEB_PAGE",
  HR_DASHBOARD_ANOMALIES: "HR_DASHBOARD_ANOMALIES_WEB_WIDGET",

  // ── HR · Attendance monitoring ──────────────────────────────────
  HR_ATTENDANCE_VIEW: "ATTENDANCE_MONITORING.ATTENDANCE_TABLE.VIEW_HR_WEB_PAGE",
  HR_ATTENDANCE_FILTERS: "ATTENDANCE_MONITORING.FILTERS.VIEW_HR_WEB_PAGE",
  HR_ATTENDANCE_STATS: "ATTENDANCE_MONITORING.STATS.VIEW_HR_WEB_PAGE",
  HR_ATTENDANCE_EDIT: "ATTENDANCE_MONITORING.MISSING_ATTENDANCE.CREATE_HR_WEB_PAGE",
  HR_ATTENDANCE_EXPORT: "ATTENDANCE_MONITORING.EXPORT_EXCEL.VIEW_HR_WEB_PAGE",

  // ── HR · Leave (not on this user's token yet) ───────────────────
  HR_LEAVE_VIEW: "VIEW_LEAVE_HR_ADMIN_WEB_PAGE",
  HR_LEAVE_APPROVE: "APPROVE_LEAVE_HR_ADMIN_WEB_BUTTON",
  HR_LEAVE_REJECT: "REJECT_LEAVE_HR_ADMIN_WEB_BUTTON",

  // ── HR · Geofences ──────────────────────────────────────────────
  HR_GEOFENCE_VIEW: "GEOFENCES.MAP.VIEW_HR_WEB_PAGE",
  HR_GEOFENCE_CREATE: "GEOFENCES.CREATE_HR_WEB_PAGE",
  HR_GEOFENCE_MANAGE: "GEOFENCES.EDIT_HR_WEB_PAGE",

  // ── HR · Employees ──────────────────────────────────────────────
  HR_EMPLOYEES_VIEW: "EMPLOYEE_MANAGEMENT.EMPLOYEE_TABLE.VIEW_HR_WEB_PAGE",
  HR_EMPLOYEES_MANAGE: "EMPLOYEE_MANAGEMENT.CREATE_HR_WEB_PAGE",

  // ── Hostels ─────────────────────────────────────────────────────
  HOSTELS_DASHBOARD_VIEW: "HOSTEL_DASHBOARD_HOSTEL_MANAGEMENT_WEB_PAGE",
  HOSTELS_MANAGE_VIEW: "MANAGE_HOSTELS_HOSTEL_MANAGEMENT_WEB_PAGE",
  HOSTELS_MANAGE_EDIT: "MANAGE_HOSTELS_BUTTON_HOSTEL_MANAGEMENT_WEB_BUTTON",
  HOSTELS_ROOMS_VIEW: "VIEW_HOSTEL_ROOMS_HOSTEL_MANAGEMENT_WEB_PAGE",
  HOSTELS_ROOMS_EDIT: "MANAGE_HOSTEL_ROOMS_HOSTEL_MANAGEMENT_WEB_BUTTON",
  HOSTELS_LAYOUT_VIEW: "VIEW_HOSTELS_LAYOUT_HOSTEL_MANAGEMENT_WEB_PAGE",
  HOSTELS_LAYOUT_EDIT: "MANAGE_HOSTEL_LAYOUT_HOSTEL_MANAGEMENT_WEB_BUTTON",
  HOSTELS_STUDENTS_VIEW: "VIEW_HOSTEL_STUDENT_DETAILS_HOSTEL_MANAGEMENT_WEB_PAGE",
  HOSTELS_STUDENTS_EDIT: "MANAGE_HOSTEL_STUDENT_DETAILS_HOSTEL_MANAGEMENT_WEB_BUTTON",
  HOSTELS_ALLOCATIONS_VIEW: "VIEW_HOSTEL_ALLOCATIONS_HOSTEL_MANAGEMENT_WEB_PAGE",
  HOSTELS_ALLOCATIONS_EDIT: "MANAGE_HOSTEL_ALLOCATIONS_HOSTEL_MANAGEMENT_WEB_BUTTON",
  HOSTELS_RESERVATIONS_VIEW: "VIEW_HOSTEL_RESERVATIONS_HOSTEL_MANAGEMENT_WEB_PAGE",
  HOSTELS_RESERVATIONS_EDIT: "MANAGE_HOSTEL_RESERVATIONS_HOSTEL_MANAGEMENT_WEB_BUTTON",
  HOSTELS_LEAVES_VIEW: "LEAVE_APPROVALS.VIEW_HOSTEL_MANAGEMENT_WEB_PAGE",
  HOSTELS_LEAVES_APPROVE: "LEAVE_APPROVALS.APPROVE_HOSTEL_MANAGEMENT_WEB_BUTTON",
  HOSTELS_REPORTS_VIEW: "VIEW_HOSTEL_REPORTS_HOSTEL_MANAGEMENT_WEB_PAGE",
  HOSTELS_AUDIT_VIEW: "VIEW_HOSTEL_AUDIT_TRAIL_HOSTEL_MANAGEMENT_WEB_PAGE",
  HOSTELS_BULK_IMPORT_VIEW: "VIEW_HOSTEL_BULK_IMPORT_HOSTEL_MANAGEMENT_WEB_PAGE",
  HOSTELS_TOKEN_DESK_VIEW: "VIEW_HOSTEL_TOKEN_DESK_HOSTEL_MANAGEMENT_WEB_PAGE",
  HOSTELS_CHECKIN_SCANNER_VIEW: "VIEW_HOSTEL_CHECKIN_SCANNER_HOSTEL_MANAGEMENT_WEB_PAGE",
  HOSTELS_GATE_MOVEMENTS_VIEW: "GATE_MOVEMENTS.VIEW_HOSTEL_MANAGEMENT_WEB_PAGE",
};

/** Parent / alias keys that imply component keys after login. */
export const RBAC_PERMISSION_EXPANSIONS = {
  // Legacy typo still seen in older clients
  "DASHBOARD.STATS.VIEW_HR_WEB_WEB_PAGE": [RBAC.HR_DASHBOARD_STATS],
  "DASHBOARD.ATTENDANCE_BREAKDOWN.VIEW_HR_WEB_WEB_PAGE": [
    RBAC.HR_DASHBOARD_ATTENDANCE_BREAKDOWN,
  ],
  // Hostel manage keys are not on all tokens yet — view access implies
  // the matching manage actions until RBAC is fully provisioned.
  // Leave Approvals and Gate Movements use dedicated keys only.
  [RBAC.HOSTELS_STUDENTS_VIEW]: [RBAC.HOSTELS_STUDENTS_EDIT, RBAC.HOSTELS_AUDIT_VIEW],
  [RBAC.HOSTELS_ALLOCATIONS_VIEW]: [
    RBAC.HOSTELS_ALLOCATIONS_EDIT,
    RBAC.HOSTELS_RESERVATIONS_VIEW,
    RBAC.HOSTELS_RESERVATIONS_EDIT,
    RBAC.HOSTELS_AUDIT_VIEW,
  ],
  [RBAC.HOSTELS_RESERVATIONS_VIEW]: [
    RBAC.HOSTELS_RESERVATIONS_EDIT,
    RBAC.HOSTELS_ALLOCATIONS_VIEW,
    RBAC.HOSTELS_ALLOCATIONS_EDIT,
    RBAC.HOSTELS_AUDIT_VIEW,
  ],
  // Until RBAC is provisioned, allocation access also opens Reservations.
  [RBAC.HOSTELS_ALLOCATIONS_EDIT]: [
    RBAC.HOSTELS_RESERVATIONS_VIEW,
    RBAC.HOSTELS_RESERVATIONS_EDIT,
    RBAC.HOSTELS_AUDIT_VIEW,
  ],
  [RBAC.HOSTELS_REPORTS_VIEW]: [RBAC.HOSTELS_AUDIT_VIEW],
};
